<div class="pt-m">
  <div class="horizontal-menu">
    <a class="horizontal-menu-item" (click)="appsRequested.emit()">
      <app-icon alt="Apps" className="w-8 h-8" src="apps.svg"></app-icon>
      <p>Apps</p>
    </a>

    <a class="horizontal-menu-item" href="/users/profile" (click)="profileRequested.emit($event)">
      <app-icon alt="Profil" className="w-8 h-8" src="profile.svg"></app-icon>
      <p>Profil</p>
    </a>

    <a class="horizontal-menu-item" (click)="logoutRequested.emit()">
      <app-icon alt="Abmelden" className="w-8 h-8" src="sign-out.svg"></app-icon>
      <p>Abmelden</p>
    </a>
  </div>
</div>
